<template>
    <button type="button" class="btn btn-secondary mr-1" @click="sort">
        <slot>
            <span>{{ label }}</span>
            <span v-if="sortable && sortable.col === col" class="ml-2">
                <fa-icon v-if="sortable.dir === 'desc'" class="sortable-icon" :icon="['fas', 'long-arrow-alt-up']"></fa-icon>
                <fa-icon v-if="sortable.dir === 'asc'" class="sortable-icon" :icon="['fas', 'long-arrow-alt-down']"></fa-icon>
            </span>
        </slot>
    </button>
</template>

<script>
export default {
  name: 'BSButtonSort',
  props: ['label', 'sortable', 'col'],
  methods: {
    sort () {
      let dir = this.sortable.dir
      if (this.sortable.col === this.col) {
        dir = dir === 'asc' ? 'desc' : 'asc'
      }
      this.$emit('click', { col: this.col, dir: dir })
    }
  }
}
</script>

<style lang="scss">
    .sortable-icon {
        position: relative;
        top: -1px;
    }
</style>
